const OPEN_DRAWERS_POP_UP = 'OPEN_DRAWERS_POP_UP';
const CLOSE_DRAWERS_POP_UP = 'CLOSE_DRAWERS_POP_UP';

export default {
  OPEN_DRAWERS_POP_UP,
  CLOSE_DRAWERS_POP_UP
};
